module.exports = __webpack_public_path__ + "assets/img/jia.24264fd0.png";